import { message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/Admin/AdminLayout";
import AdminHeader from "./component/AdminHeader";
import noresult from "../../images/noresult.png";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Select } from "antd";
const { Option } = Select;

const AdminAddReviews = () => {
  const [loading, setLoading] = useState(false);
  const [reviews, setReviews] = useState(null);
  const [categories, setCategories] = useState([]); // ✅ categories
  const [travelThemes, setTravelThemes] = useState([]); // ✅ travel themes

  const [modalMsg, setModalMsg] = useState(null);
  const [image, setImage] = useState(null);
  const [editingId, setEditingId] = useState(null);

  const [inputField, setInputField] = useState({
    name: "",
    date: "",
    review: "",
   category: [], // changed from string to array
  travelTheme: [], // ✅ added this

      packageUrl: "", // ✅ Add this

  });

  // ---------- Fetch Reviews ----------
  const getAllReviews = async () => {
    try {
      const res = await axios.get(`api/review/get-all-reviews`);
      setReviews(res.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  // ---------- Fetch Categories ----------
  const getAllCategories = async () => {
    try {
      const res = await axios.get(`api/category/get-all-category`);
;
      setCategories(res.data.data || []);
    } catch (err) {
      console.log(err);
    }
  };
const getAllTravelThemes = async () => {
  try {
    const res = await axios.get(`api/travel-theme/get-all-travel-themes`);
    setTravelThemes(res.data.data || []);
  } catch (err) {
    console.log(err);
  }
};

  useEffect(() => {
    if (reviews === null) getAllReviews();
    if (categories.length === 0) getAllCategories();
    if (travelThemes.length === 0) getAllTravelThemes();

    // eslint-disable-next-line
  }, []);

  // ---------- Submit Add / Update ----------
  const submit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", inputField.name);
    formData.append("review", inputField.review);
    formData.append("date", inputField.date);
formData.append("category", JSON.stringify(inputField.category));
formData.append("travelTheme", JSON.stringify(inputField.travelTheme));
formData.append("source", "admin");


    formData.append("packageUrl", inputField.packageUrl);

    if (image) formData.append("image", image);

    setLoading(true);

    const url = editingId
      ? `api/review/update-review/${editingId}`
      : `api/review/add-review`;

    axios({
      method: "POST",
      data: formData,
      withCredentials: true,
      url,
    })
      .then((res) => {
        getAllReviews();
        setTimeout(() => setLoading(false), 1000);
setInputField({
      name: "",
      date: "",
      review: "",
        category: [],
  travelTheme: [],

      packageUrl: "", // ✅ added reset field
    });
        setEditingId(null);
        message.success(res.data.message);
      })
      .catch((err) => {
        setTimeout(() => setLoading(false), 1000);
        message.error(err?.response?.data?.message || "Something went wrong");
        console.log(err);
      });
  };

  // ---------- Delete ----------
  const deleteReview = (id) => {
    axios({
      method: "POST",
      data: { id },
      withCredentials: true,
      url: `api/review/delete-review`,
    })
      .then((res) => {
        getAllReviews();
        message.success(res.data.message);
      })
      .catch((err) => {
        console.log(err);
        message.error("Failed to delete review");
      });
  };

  // ---------- Edit ----------
  const startEdit = (review) => {
    setInputField({
      name: review.name,
      date: review.date,
      review: review.review,
       category: Array.isArray(review.category) ? review.category : [review.category],
  travelTheme: Array.isArray(review.travelTheme)
    ? review.travelTheme
    : [review.travelTheme],
          packageUrl: review.packageUrl || "", // ✅ prefill if exists

    });
    setEditingId(review._id);
    setImage(null);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ---------- Handle Input ----------
  const hanleChange = (event) => {
    setInputField({ ...inputField, [event.target.name]: event.target.value });
  };
 // ✅ Add this helper function here
  const parseCategory = (cat) => {
    if (!cat) return [];
    if (Array.isArray(cat)) return cat;
    try {
      const parsed = JSON.parse(cat); // handle stringified arrays
      return Array.isArray(parsed) ? parsed : [parsed];
    } catch {
      return typeof cat === "string" ? cat.split(",").map((c) => c.trim()) : [];
    }
  };
  return (
    <div>
      <Layout>
        <AdminHeader title="Site Reviews" redirect="/admin-dashboard" />
        <div className="Mon_font px-3 m-0 pb-4">
          {/* ---------- Form ---------- */}
          <form
            className="row g-3 m-0 px-2 py-3 rounded border border-2"
            style={{ backgroundColor: "#f5f5f5" }}
            onSubmit={submit}
          >
            <div className="col-6">
              <input
                className="form-control"
                value={inputField.name}
                type="text"
                name="name"
                required
                placeholder="Enter name"
                onChange={hanleChange}
                maxLength={200}
              />
            </div>
            <div className="col-6">
              <input
                className="form-control"
                value={inputField.date}
                type="date"
                name="date"
                required
                onChange={hanleChange}
              />
            </div>
            <div className="col-6">
           <Select
  mode="multiple"
  allowClear
  style={{ width: "100%" }}
  placeholder="Select categories"
  value={inputField.category}
  onChange={(selected) => setInputField({ ...inputField, category: selected })}
  options={categories.map((cat) => ({
    label: cat.name,
    value: cat.name,
  }))}
/>

<Select
  mode="multiple"
  allowClear
  style={{ width: "100%", marginTop: "10px" }}
  placeholder="Select travel themes"
  value={inputField.travelTheme}
  onChange={(selected) =>
    setInputField({ ...inputField, travelTheme: selected })
  }
  options={travelThemes.map((theme) => ({
    label: theme.name,
    value: theme.name,
  }))}
/>


            </div>
            <div className="col-6">
  <input
    className="form-control"
    value={inputField.packageUrl}
    type="text"
    name="packageUrl"
    placeholder="Enter package URL (optional)"
    onChange={hanleChange}
  />
</div>

            <div className="col-6">
              <input
                aria-label="Select Image"
                className="form-control"
                type="file"
                name="image"
                onChange={(e) => setImage(e.target.files[0])}
              />
            </div>
            <div className="col-12">
              <textarea
                rows="6"
                style={{ resize: "none" }}
                className="form-control"
                value={inputField.review}
                type="text"
                name="review"
                required
                placeholder="description"
                onChange={hanleChange}
              />
            </div>
            <div className="col-2 d-flex justify-content-center align-items-center">
              <button type="submit" className="btn btn-warning w-100">
                {loading ? "Loading..." : editingId ? "Update" : "Save"}
              </button>
            </div>
            {editingId && (
              <div className="col-2 d-flex justify-content-center align-items-center">
                <button
                  type="button"
                  className="btn btn-secondary w-100"
                  onClick={() => {
                    setEditingId(null);
                    setInputField({ name: "", date: "", review: "",  category: [],packageUrl: "", });
                    setImage(null);
                  }}
                >
                  Cancel
                </button>
              </div>
            )}
          </form>

          {/* ---------- Table ---------- */}
          {reviews?.length === 0 ? (
            <div className="d-flex flex-column justify-content-center align-items-center mt-5">
              <img src={noresult} alt="" width={150} />
              <h3>No Record Found</h3>
            </div>
          ) : (
            <div className="w-100 mt-5 Mon_font overflow-auto">
              <div className="d-flex justify-content-end m-0">
                <p className="m-0 mb-3">Total Reviews: {reviews?.length}</p>
              </div>
              <table className="table border">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>Name</th>
                    <th>Category</th>
                        <th>Travel Theme</th> {/* ✅ Added this */}

                    <th>Image</th>
                    <th>Review</th>
                        <th>Package URL</th> {/* ✅ added */}
<th>Source</th>

                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {reviews &&
                    reviews.map((blog, index) => {
                      const date = new Date(blog?.date);
                      const day = date.toLocaleDateString("en-US", { day: "numeric" });
                      const month = date.toLocaleDateString("en-US", { month: "short" });
                      const year = date.toLocaleDateString("en-US", { year: "numeric" });

                      return (
                        <tr key={blog._id}>
                          <td>{index + 1}</td>
                          <td>{day + " " + month + " " + year}</td>
                          <td>{blog?.name}</td>
<td>{parseCategory(blog?.category).join(", ") || "-"}</td>
<td>{parseCategory(blog?.travelTheme).join(", ") || "-"}</td> {/* ✅ Added this */}

<td>
                            <img
                              width="50px"
                              height="50px"
                              src={`/reviewImages/${blog?.image}`}
                              alt=""
                            />
                          </td>
                          <td>
                            <Link
                              to="#"
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModal"
                              onClick={() => setModalMsg(blog?.review)}
                            >
                              View
                            </Link>
                          </td>
                          {/* ✅ Add this new column here */}
  <td>
    {blog?.packageUrl ? (
      <a href={blog.packageUrl} target="_blank" rel="noopener noreferrer">
        Visit
      </a>
    ) : (
      "-"
    )}
  </td>
 <td>
  {blog?.source === "user" ? (
    <span
      style={{
        display: "inline-block",
        padding: "3px 8px",
        borderRadius: "4px",
        fontSize: "12px",
        fontWeight: 600,
        backgroundColor: "#28a745",
        color: "#ffffff"
      }}
    >
      User
    </span>
  ) : blog?.source === "admin" ? (
    <span
      style={{
        display: "inline-block",
        padding: "3px 8px",
        borderRadius: "4px",
        fontSize: "12px",
        fontWeight: 600,
        backgroundColor: "#007bff",
        color: "#ffffff"
      }}
    >
      Admin
    </span>
  ) : (
    <span
      style={{
        display: "inline-block",
        padding: "3px 8px",
        borderRadius: "4px",
        fontSize: "12px",
        fontWeight: 600,
        backgroundColor: "#6c757d",
        color: "#ffffff"
      }}
    >
      Old
    </span>
  )}
</td>



                          <td className="border d-flex gap-2">
                            <EditIcon
                              onClick={() => startEdit(blog)}
                              className="text-primary"
                              style={{ cursor: "pointer" }}
                            />
                            <DeleteIcon
                              onClick={() => deleteReview(blog?._id)}
                              className="text-danger"
                              style={{ cursor: "pointer" }}
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>

              {/* Review Modal */}
              <div className="modal" tabIndex="-1" id="exampleModal">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Review</h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => setModalMsg(null)}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <p>{modalMsg}</p>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary btn-sm"
                        data-bs-dismiss="modal"
                        onClick={() => setModalMsg(null)}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </Layout>
    </div>
  );
};

const style = {
  fontSize: "13px",
};

export default AdminAddReviews;
